export default class Locale_LookupProject {
	IncludeInactiveProjects: string = "Include inactive projects";
}